import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import styled from "styled-components";

interface InViewTriggerProps {
  onInView?: () => any;
}

const Temp = styled.div``;

export const InViewTrigger: React.FC<InViewTriggerProps> = ({
  children,
  onInView,
}) => {
  const { ref, inView } = useInView({
    rootMargin: "-50% 0px -50% 0px",
  });

  useEffect(() => {
    if (inView) {
      onInView && onInView();
    }
  }, [inView, onInView]);
  return <Temp ref={ref}>{children}</Temp>;
};
